import { render } from "./BackListing.vue?vue&type=template&id=bd8c5fd2"
import script from "./BackListing.vue?vue&type=script&lang=js"
export * from "./BackListing.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__